 
import { SourceOfFundIdsEnum } from '../enums';

export class SourceOfFundsTrait {
    private constructor() {
    }

    static getSalaryIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricSalary,
            SourceOfFundIdsEnum.Alaric10nSalary
        ];
    }

    static getAtHomeTradingIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricAtHomeTrading,
            SourceOfFundIdsEnum.Alaric10nAtHomeTrading
        ];
    }
 
    static getInheritanceIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricInheritance,
            SourceOfFundIdsEnum.Alaric10nInheritance
        ];
    }

    static getFamilyMemberIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricFamilyMember,
            SourceOfFundIdsEnum.Alaric10nFamilyMember
        ];
    }

    static getPensionBenefitProgramIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricPensionBenefitProgram,
            SourceOfFundIdsEnum.Alaric10nPensionBenefitProgram
        ];
    }

    static getInvestmentsAndSavingsIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricInvestmentsAndSavings,
            SourceOfFundIdsEnum.Alaric10nInvestmentsAndSavings
        ];
    }

    static getSelfEmploymentIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricSelfEmployment,
            SourceOfFundIdsEnum.Alaric10nSelfEmployment
        ];
    }

    static getLoanIds(): SourceOfFundIdsEnum[] {
        return [
            SourceOfFundIdsEnum.AlaricLoan,
            SourceOfFundIdsEnum.Alaric10nLoan
        ];
    }
}
